import styles from "./styles.module.css";
import { useNavigate } from "react-router-dom";

type Props = {
  id: number;
  titulo: string;
  descricao: string;
  inicio: Date;
  fim: Date;
};

const RowColaboracoes = ({ id, titulo, descricao, inicio, fim }: Props) => {
  const navigate = useNavigate();
  return (
    <tr className={styles.row}>
      <td>{titulo}</td>
      <td>{descricao}</td>
      <td className={styles.prazo}>
        {`${new Date(inicio).toLocaleDateString()} à ${new Date(
          fim
        ).toLocaleDateString()}`}
      </td>
      <td>
        <button
          className={styles.addBtn}
          onClick={(e) => {
            e.preventDefault();
            navigate(`/novo-plano`, { state: id });
          }}
        >
          Colaboração
        </button>
      </td>
    </tr>
  );
};
export default RowColaboracoes;
